import { useEffect, useState } from 'react';
import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export interface GovernanceStatus {
  actorRef: string;
  isAdmin: boolean;
  enforceTemplateAccess: boolean;
}

export function useGovernanceStatus(): {
  status?: GovernanceStatus;
  error?: Error;
} {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);
  const [status, setStatus] = useState<GovernanceStatus>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const [baseUrl, credentials] = await Promise.all([
          discoveryApi.getBaseUrl('arta-governance'),
          identityApi.getCredentials(),
        ]);
        const response = await fetch(`${baseUrl}/status`, {
          headers: credentials.token
            ? { Authorization: `Bearer ${credentials.token}` }
            : {},
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(
            body.error ??
              `Governance status failed with HTTP ${response.status}`,
          );
        }
        if (active) setStatus(body);
      } catch (cause) {
        if (active) {
          setError(cause instanceof Error ? cause : new Error(String(cause)));
        }
      }
    }
    load();
    return () => {
      active = false;
    };
  }, [discoveryApi, identityApi]);

  return { status, error };
}
